"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidStateCode = exports.normalizeStateCode = exports.US_STATE_CODE_LIST = void 0;
const US_STATE_NAME_TO_CODE = {
    "alabama": "AL",
    "alaska": "AK",
    "american samoa": "AS",
    "arizona": "AZ",
    "arkansas": "AR",
    "california": "CA",
    "colorado": "CO",
    "connecticut": "CT",
    "delaware": "DE",
    "district of columbia": "DC",
    "federated states of micronesia": "FM",
    "florida": "FL",
    "georgia": "GA",
    "guam": "GU",
    "hawaii": "HI",
    "idaho": "ID",
    "illinois": "IL",
    "indiana": "IN",
    "iowa": "IA",
    "kansas": "KS",
    "kentucky": "KY",
    "louisiana": "LA",
    "maine": "ME",
    "marshall islands": "MH",
    "maryland": "MD",
    "massachusetts": "MA",
    "michigan": "MI",
    "minnesota": "MN",
    "mississippi": "MS",
    "missouri": "MO",
    "montana": "MT",
    "nebraska": "NE",
    "nevada": "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    "northern mariana islands": "MP",
    "ohio": "OH",
    "oklahoma": "OK",
    "oregon": "OR",
    "palau": "PW",
    "pennsylvania": "PA",
    "puerto rico": "PR",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    "tennessee": "TN",
    "texas": "TX",
    "utah": "UT",
    "vermont": "VT",
    "virgin islands": "VI",
    "virginia": "VA",
    "washington": "WA",
    "west virginia": "WV",
    "wisconsin": "WI",
    "wyoming": "WY"
};
/** Same codes `isValidStateCode` accepts, sorted for state dropdowns. */
exports.US_STATE_CODE_LIST = Object.values(US_STATE_NAME_TO_CODE).sort();
const US_STATE_CODES = new Set(exports.US_STATE_CODE_LIST);
exports.normalizeStateCode = (state) => {
    if (!state) {
        return "";
    }
    const compactState = String(state)
        .trim()
        .replace(/\./g, "")
        .replace(/\s+/g, " ");
    if (!compactState) {
        return "";
    }
    const upperState = compactState.toUpperCase();
    if (upperState.length === 2 && US_STATE_CODES.has(upperState)) {
        return upperState;
    }
    return US_STATE_NAME_TO_CODE[compactState.toLowerCase()] || upperState;
};
exports.isValidStateCode = (state) => {
    return !!state && US_STATE_CODES.has(state);
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/util/state-normalize.ts
// module id = 4032
// module chunks = 0